export default __webpack_public_path__ + "static/media/home-slider-background-left.e4411787.png";